module.exports = __webpack_public_path__ + "img/cast_logo-b.5fbaf888.svg";